import { RichTextBlock } from 'prismic-reactjs'
import { FC } from 'react'
import styled from 'styled-components'
import { ImageField } from '@prismicio/client'

import { PageContainer } from '../../layout/containers/PageContainer'
import { media } from '../../utils/style-utils'
import RichText from '../RichText'
import StepCard from '../StepCard/StepCard'
import CardContainer from '../CardContainer/CardContainer'
import { backgroundColors } from '../../styles/backgroundColors'

interface IWebSolutions {
	slice: {
		primary: {
			title: RichTextBlock[]
			description: RichTextBlock[]
			content: RichTextBlock[]
			image: ImageField
			darkMode: boolean
			stepsHeading?: RichTextBlock[]
		}
		items: {
			backgroundColor: string
			stepNumber: number
			stepText: RichTextBlock[]
		}[]
	}
}

const WebSolutions: FC<IWebSolutions> = ({ slice }) => (
	<WebSolutionsContainer
		darkMode={slice.primary.darkMode}
		options={{ backgroundColor: slice.primary.darkMode ? backgroundColors('Deep Blue') : backgroundColors('Neon') }}
	>
		<ContentWrapper>
			<TextWrapper darkMode={slice.primary.darkMode}>
				<StyledTitle content={slice.primary.title} />
				<StyledDescription content={slice.primary.description} />
				<StyledContent content={slice.primary.content} />
			</TextWrapper>
			<ImageContainer>
				<Image
					src={slice.primary.image.url ?? ''}
					alt={slice.primary.image.alt ?? ''}
				/>
			</ImageContainer>
		</ContentWrapper>
		{slice.primary.stepsHeading &&
			slice.primary.stepsHeading.length > 0 &&
			slice.primary.stepsHeading[0].text?.length !== 0 && (
				<StepsHeading
					darkMode={slice.primary.darkMode}
					content={slice.primary.stepsHeading}
				/>
			)}

		<StyledStepCards>
			{slice.items.map((item, index) => (
				<StepCard
					item={item}
					key={index}
					darkMode={slice.primary.darkMode}
				/>
			))}
		</StyledStepCards>
	</WebSolutionsContainer>
)

export default WebSolutions

const WebSolutionsContainer = styled(CardContainer)<{ darkMode: boolean }>`
	display: flex;
	flex-direction: column;
`

const ContentWrapper = styled.div`
	display: flex;
	padding: 96px 0 53px 96px;

	${media.tablet`
        flex-direction: column;
        padding: 42px 24px;
    `}
`

const TextWrapper = styled.div<{ darkMode: boolean }>`
	color: ${(props) => (props.darkMode ? backgroundColors('Neon') : backgroundColors('Deep Blue'))};
	width: 50%;
	margin-bottom: 0;

	${media.tablet`
        width: 100%;
    `}
`

const StyledTitle = styled(RichText)`
	h1 {
		margin: 0;
	}
`
const StyledDescription = styled(RichText)`
	p {
		font-family: var(--font-atyp-display);
		font-style: normal;
		font-weight: 400;
		font-size: 2rem;
		line-height: 2.5rem;
		max-width: 500px;
	}
`
const StyledContent = styled(RichText)`
	p {
		font-family: var(--font-akzidenz);
		font-style: normal;
		font-weight: 400;
		font-size: 1.25rem;
		line-height: 2rem;
	}

	a {
		text-decoration: underline;
	}
`
const ImageContainer = styled.div`
	width: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	${media.desktopSm`
        width: 100%;
    `}
`
const Image = styled.img`
	width: 491px;
	height: 411px;
	object-fit: contain;

	${media.desktopSm`
		width: 100%;
		height: auto;
		width: 80%;
	`}
`

const StepsHeading = styled(RichText)<{ darkMode: boolean }>`
	color: ${(props) => (props.darkMode ? backgroundColors('Neon') : backgroundColors('Deep Blue'))};
	padding-left: 96px;
	p {
		font-family: var(--font-atyp-display);
		font-style: normal;
		font-weight: 500;
		font-size: 1.5rem;
		line-height: 1.8125rem;
		margin-top: 0;
	}

	${media.tablet`
        padding-left: 16px;
        margin-top: 0px;
    `}
`

const StyledStepCards = styled.div`
	${PageContainer}
	padding: 0 1.5rem 3rem;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: var(--spacer-xs);

	${media.phone`
		gap: var(--spacer-xs);
		padding: 0 .5rem 1rem;
	`};
`
